import { render, staticRenderFns } from "./NewDeliveryOrder.vue?vue&type=template&id=24a07a1c&scoped=true"
import script from "./NewDeliveryOrder.vue?vue&type=script&lang=js"
export * from "./NewDeliveryOrder.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewDeliveryOrder.vue?vue&type=style&index=1&id=24a07a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a07a1c",
  null
  
)

export default component.exports